<div *ngIf="countDown" >
    <label>{{countDown | formatTime}}</label>
</div>
    
    